import { render, staticRenderFns } from "./PromotionRowV2.vue?vue&type=template&id=17510384&scoped=true&"
import script from "./PromotionRowV2.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PromotionRowV2.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PromotionRowV2.vue?vue&type=style&index=0&id=17510384&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17510384",
  null
  
)

export default component.exports